import { JSX } from "react";
import ArrowIcon from "./Components/ArrowIcon";
import InfrastructureHero from "./Components/InfrastructureHero";
import InfrastructureNavCards from "./Components/InfrastructureNavCards";
import InfrastructureSection from "./Components/InfrastructureSection";
import useScrollToHash from "./Components/useScrollToHash";

const strategyCards = [
    {
        id: "infrastructure",
        title: "Infrastructure funding challenge or funding gap",
    },
    {
        id: "infrastructureinnovationpracticesdesired",
        title: "Infrastructure and its desired partnership outcomes",
    },
    {
        id: "panopticprinciples",
        title: "Panoptic principles and ease of compliance to prescripts",
    },
    {
        id: "WGsingularinvestment",
        title: "WG singular investment-ready project pipeline",
    },
];

type Section = {
    id: string;
    tag: string;
    title: string;
    sideImage?: string;
    description?: JSX.Element;
    variant?: "gray" | "white";
    content: JSX.Element;
};



const sections: Section[] = [
    {
        id: "infrastructure",
        tag: "WCIIP 2050",
        title: "Western Cape infrastructure portfolio foundations:",
        content: (
            <ul>
                <li>Scan existing pipelines across public-private sectors</li>
                <li>
                    Prioritise from step 1, projects that comply to 2 x filters (PSP + rough Estimate)
                </li>
                <li>Evaluate projects using Panoptic model for compliance</li>
                <li>
                    Package all compliant projects to support trusted investor-ready pipeline
                </li>
            </ul>
        ),
    },
    {
        id: "infrastructureinnovationpracticesdesired",
        tag: "WCIIP 2050",
        title: "Infrastructure and its desired partnership outcomes:",
        content: (
            <ul>
                <li>
                    Funding, Financing innovation (BFF) aspects – synchronise public-private sector investment efforts
                </li>
                <li>
                    Partnership aspects – Secure and promote partnerships that build trust, and collaborate on risk-rewards sharing
                </li>
            </ul>
        ),
        variant: "gray",
    },
    {
        id: "panopticprinciples",
        tag: "WCIIP 2050",
        title: "Panoptic principles and ease of compliance to prescripts:",
        content: (
            <ul>
                <li>
                    Principle 1 <ArrowIcon /> Infrastructure innovation that drives economic, social and environmental development
                </li>
                <li>
                    Principle 2 <ArrowIcon /> Innovative infrastructure value chains to build locally bound resilient systems
                </li>
                <li>
                    Principle 3 <ArrowIcon /> Sustainable value creation via spatially just infrastructure services that builds trust (see IDA)
                </li>
                <li>
                    Principle 4 <ArrowIcon /> Transversal infrastructure governance from design, planning, development and asset life cycle management
                </li>
            </ul>
        ),
    },
    {
        id: "WGsingularinvestment",
        tag: "WCIF 2050",
        title: "WG singular investment-ready project pipeline:",
        content: (
            <ul>
                <li>
                    STEP 1 <ArrowIcon /> Use existing project pipelines from across the WC public-private sectors
                </li>
                <li>
                    STEP 2 <ArrowIcon /> Prioritise projects from step 1 using two basic filters (a) match to PSP; (b) Draft budget
                </li>
                <li>
                    STEP 3 <ArrowIcon /> Take prioritised projects, test and refine using Panoptic model to build elevator pitch and prospectus
                </li>
                <li>
                    STEP 4 <ArrowIcon /> Continuously build the project pipeline to encourage investment into a trusted, compliant infrastructure portfolio
                </li>
            </ul>
        ),
        variant: "gray",
    },
];
const WesternCapeInfrastructureImplementationPlan = () => {
    useScrollToHash();

    return (
        <section className="western-cape-infrastructure-strategy-page frame-work bg-white overflow-auto">

            <InfrastructureHero
                pdf="pdfs/public-pages/2025-04-04-WCIIP-2050.pdf"
                logo="media/images/wciip2025.png"
                logoAlt="WCIIP 2050"
            >
                <InfrastructureNavCards
                    cards={strategyCards}
                    baseUrl="/pages/western-cape-infrastructure-implementation-plan"
                />
            </InfrastructureHero>

            {sections.map((section) => (
                <InfrastructureSection
                    key={section.id}
                    {...section}
                />
            ))}

        </section>
    );
};

export default WesternCapeInfrastructureImplementationPlan;